export enum HrCapitalFormationTierModalMode {
  CREATE = "create",
  VIEW = "view",
  EDIT = "edit",
}
